import { useDebouncedCallback } from './useDebouncedCallback.ts';
import { round } from './format.ts';

export interface NumberFieldProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  unit?: string;
  decimals?: number;
  onChange: (value: number) => void;
  /** Debounce delay (ms) for the slider; the number input always commits immediately. */
  debounceMs?: number;
}

/** A labelled slider + number input pair, in metric units, right-aligned value. */
export function NumberField(props: NumberFieldProps) {
  const { label, value, min, max, step, unit, decimals = 0, onChange, debounceMs = 120 } = props;
  const commit = useDebouncedCallback(onChange, debounceMs);
  const shown = round(value, decimals);

  return (
    <div class="field">
      <div class="field-row">
        <span class="field-label">{label}</span>
        <span class="field-value">
          <input
            type="number"
            min={min}
            max={max}
            step={step}
            value={shown}
            onChange={(e) => onChange(Number((e.target as HTMLInputElement).value))}
          />
          {unit ? <span class="unit">{unit}</span> : null}
        </span>
      </div>
      <input
        type="range"
        class="field-slider"
        min={min}
        max={max}
        step={step}
        value={value}
        onInput={(e) => commit(Number((e.target as HTMLInputElement).value))}
      />
    </div>
  );
}
